import { render } from "./StudentPlaceSharedFiles.vue?vue&type=template&id=468310f6&scoped=true"
import script from "./StudentPlaceSharedFiles.vue?vue&type=script&lang=js"
export * from "./StudentPlaceSharedFiles.vue?vue&type=script&lang=js"

import "./StudentPlaceSharedFiles.vue?vue&type=style&index=0&id=468310f6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-468310f6"]])

export default __exports__